import { axios } from '@/utils/request'
const api = {
  LoginCodeAvatar: '/sso/code/getImgCode', // 图形验证码
  LoginCheckImgCode: '/sso/code/checkImgCode', // 短信验证与校验四位验证码
  PhoneCodeInterface: '/sso/ThirdInterface/phoneCodeInterface', // 国际区号
  BindLoginCheckImgCode: '/sso/code/smsCode' // 短信验证与校验四位验证码
}

export default api
export const LoginCodeAvatar = async params => axios.post(api.LoginCodeAvatar, params)
export const LoginCheckImgCode = async params => axios.post(api.LoginCheckImgCode, Object.assign({ systemCode: 'SSO_SYS_USER' }, params))
export const BindLoginCheckImgCode = async params => axios.post(api.BindLoginCheckImgCode, Object.assign({ systemCode: 'SSO_SYS_USER' }, params))
export const PhoneCodeInterface = async params => axios.post(api.PhoneCodeInterface, params) // 区号
